import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useReportsSocket = (identifier: string): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Reports);

  useEffect(() => {
    if (identifier) {
      const newSocket = getSocket();

      setSocket(newSocket);

      newSocket.emit('subscribe', identifier);

      return () => {
        newSocket.emit('unsubscribe', identifier);
        newSocket.disconnect();
      };
    }
  }, [getSocket, identifier]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Reports);

  return socket;
};